import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL } from '../../shared/constants';
import {
  CompanyTimeSeriesResponse,
  GetCompaniesStatsResponse,
  GetCompanyStatsResponse,
  TimeSeriesGranularity,
} from '../responseTypes/company';
import type { RootState } from '../store';

const baseUrl = 'v2/dashboard-share';

const shareBaseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).share.token;
    if (token) headers.set('Authorization', `Bearer ${token}`);
    return headers;
  },
});

export const shareApi = createApi({
  reducerPath: 'shareApi',
  baseQuery: shareBaseQuery,
  endpoints: (build) => ({
    getCompaniesStats: build.query<
      GetCompaniesStatsResponse,
      {
        limit?: number;
        offset?: number;
        query?: string;
        fromDate?: string;
        toDate?: string;
      }
    >({
      query: ({ limit = 1000, offset = 0, query = '', fromDate, toDate }) => ({
        url: `${baseUrl}/companies/stats`,
        params: {
          limit,
          offset,
          query,
          ...(fromDate !== undefined && toDate !== undefined
            ? { fromDate, toDate }
            : {}),
        },
      }),
    }),
    getCompanyStats: build.query<
      GetCompanyStatsResponse,
      { companyId: string }
    >({
      query: ({ companyId }) => ({
        url: `${baseUrl}/companies/${companyId}/stats`,
      }),
    }),
    getCompanyStatsTimeseries: build.query<
      CompanyTimeSeriesResponse,
      {
        companyId: string;
        fromDate: string;
        toDate: string;
        granularity?: TimeSeriesGranularity;
        metrics?: string;
      }
    >({
      query: ({ companyId, fromDate, toDate, granularity, metrics }) => ({
        url: `${baseUrl}/companies/${companyId}/stats/timeseries`,
        params: {
          fromDate,
          toDate,
          ...(granularity ? { granularity } : {}),
          ...(metrics ? { metrics } : {}),
        },
      }),
    }),
  }),
});
